<template>
  <section>
    <v-row>
      <v-col>
        <v-btn
          @click="showDetails = !showDetails"
          color="blue"
          dark
          class="ml-2"
        >
          <span v-if="showDetails">Дэлгэрэнгүй</span>
          <span v-else>Xураангуй</span></v-btn
        >
      </v-col>
      <v-col>
        <v-btn
          color="secondary"
          @click="_confirmGPACalculation(allCreditPoints, allCredit)"
          >баталгаажуулаx</v-btn
        >
      </v-col>
      <v-col>
        <small class="red--text" v-if="student._confirmed_calculated_date">
          сүүлд баталгаажуулсан xугацаа
          {{
            student._confirmed_calculated_date.toDate()
              | moment("YYYY/MM/DD HH:MM")
          }}</small
        >
      </v-col>
    </v-row>
    <v-card
      style="width: 1000px"
      class="mx-auto pt-5 pb-10"
      id="printMe"
      v-if="item && item.code && item.code == '001'"
    >
      <v-container style="background: white; margin-top: 40px">
        <v-row>
          <v-col cols="3" class="text-center">
            <img
              v-if="student.school && student.school.schoolIndex == 1"
              style="width: 100px; height: 128px"
              src="@/assets/img/logo1.jpg"
              alt="Avatar"
              class="border-radius-lg"
            />
            <img
              v-else-if="student.school && student.school.schoolIndex == 2"
              style="width: 100px; height: 128px"
              src="@/assets/img/logo2.jpg"
              alt="Avatar"
              class="border-radius-lg"
            />
          </v-col>
          <v-col cols="6" class="text-center">
            <h5 class="text-uppercase mb-4">{{ student.school.name }}</h5>
            <p style="font-size: 7pt; margin: 0pt">
              Улаанбаатар хот. Баянгол дүүрэг 5 - р хороо, Энхтайвны өргөн чөлөө
            </p>
            <p style="font-size: 7pt; margin: 0pt">Утас/факс: 7000-7631</p>
            <p style="font-size: 7pt">Цахим шуудан:info@iet.edu.mn</p>
          </v-col>
          <v-col cols="3" class="text-center">
            <img
              style="width: 128px; height: 128px"
              src="@/assets/img/user.jpg"
            />
          </v-col>
        </v-row>
        <hr />
        <h4 class="text-center" style="margin-bottom: 40px; margin-top: 40px">
          Дүнгийн тодорxойлолт  
        </h4>
        <v-row v-if="student.role == 'student' && classInfo" class="ml-4">
          <v-col cols="6">
            <table>
              <tr>
                <td class="text-start">Эцэг/эхийн нэр</td>
                <td style="width: 10%"></td>
                <td class="font-weight-bold text-start">
                  {{ student.lastName }}
                </td>
              </tr>
              <tr>
                <td class="text-start">Өөрийн нэр</td>
                <td style="width: 10%"></td>
                <td class="font-weight-bold text-start">
                  {{ student.firstName }}
                </td>
              </tr>
              <tr>
                <td class="text-start">Регистрийн дугаар</td>
                <td style="width: 10%"></td>
                <td class="font-weight-bold text-start text-uppercase">
                  {{ student.register }}
                </td>
              </tr>
              <tr>
                <td class="text-start">Суралцагчийн дугаар</td>
                <td style="width: 10%"></td>
                <td class="font-weight-bold text-start text-uppercase">
                  {{ student.studentCode }}
                </td>
              </tr>
              <tr>
                <td class="text-start">Хичээлийн жил</td>
                <td style="width: 10%"></td>
                <td class="font-weight-bold text-start">
                  {{ student.school.currentSemesterYears }}
                  {{ student.school.currentSemesterName }}
                </td>
              </tr>
            </table>
          </v-col>
          <v-col cols="6" class="text-end">
            <table>
              <tr>
                <td class="text-start">Хөтөлбөрийн индекс</td>
                <td style="width: 10%"></td>
                <td class="font-weight-bold text-start">
                  <span v-if="classInfo.xProfession">
                    {{ classInfo.xProfession.xcurriculumIndex }}</span
                  >
                  <span v-else class="red--text">NOT FOUND</span>
                </td>
              </tr>
              <tr>
                <td class="text-start">Хөтөлбөр</td>
                <td style="width: 10%"></td>
                <td class="font-weight-bold text-start">
                  {{ classInfo.xcurriculumName }}
                </td>
              </tr>
              <tr>
                <td class="text-start">Зэрэг</td>
                <td style="width: 10%"></td>
                <td class="font-weight-bold text-start">
                  {{ classInfo.xprofessiondegreeName }}
                </td>
              </tr>
              <tr>
                <td class="text-start">Үнэлгээний голч</td>
                <td style="width: 10%"></td>
                <td class="font-weight-bold text-start">
                  <!-- {{ student.currentGPA }} -->
                  {{ (allCreditPoints / allCredit).toFixed(2) }}
                  <span v-if="showDetails"
                    ><span
                      style="background-color: green; color: white"
                      class="mr-2"
                      >{{ student.currentGPA }}</span
                    >
                    <span style="background-color: yellow">{{
                      allCreditPoints.toFixed(2)
                    }}</span>
                  </span>
                </td>
              </tr>
              <tr>
                <td class="text-start">Нийт кредит цаг</td>
                <td style="width: 10%"></td>
                <td class="font-weight-bold text-start">
                  {{ allCredit }}
                </td>
              </tr>
            </table>
          </v-col>
        </v-row>
      </v-container>
      <v-container style="margin-bottom: 40px; margin-top: 5px">
        <template v-if="studentScores && studentScores.length > 0">
          <div
            class="scoreTableTodorhoilolt px-10"
            v-for="(yearScore, yIndex) in this.yearScores"
            :key="'dd' + yIndex"
          >
            <div v-for="(sem, semIndex) in [1, 2]" :key="'sem' + semIndex">
              <template v-if="_getYearTotalCredit(yearScore, sem) > 0">
                <table
                  v-if="yearScore.length > 0"
                  class="px-10 scoreBorderedTable my-4"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th
                        class="scoreTableTodorhoilolt-hcell"
                        style="
                          border: 1px solid black;
                          text-align: left;
                          padding: 8px;
                          font-weight: bold !important;
                        "
                      >
                        Хичээлийн жил
                      </th>
                      <th
                        class="scoreTableTodorhoilolt-hcell"
                        style="
                          border: 1px solid black;
                          text-align: left;
                          padding: 8px;
                          font-weight: bold !important;
                        "
                      >
                        Улирал
                      </th>
                      <th
                        class="scoreTableTodorhoilolt-hcell"
                        style="
                          border: 1px solid black;
                          text-align: left;
                          padding: 8px;
                          font-weight: bold !important;
                        "
                      >
                        Код
                      </th>
                      <th
                        class="scoreTableTodorhoilolt-hcell"
                        style="
                          border: 1px solid black;
                          text-align: left;
                          padding: 8px;
                          font-weight: bold !important;
                        "
                      >
                        Хичээл
                      </th>
                      <th
                        class="scoreTableTodorhoilolt-hcell"
                        style="
                          border: 1px solid black;
                          text-align: left;
                          padding: 8px;
                          font-weight: bold !important;
                        "
                      >
                        Кр
                      </th>
                      <th
                        class="scoreTableTodorhoilolt-hcell"
                        style="
                          border: 1px solid black;
                          text-align: left;
                          padding: 8px;
                          font-weight: bold !important;
                        "
                      >
                        Оноо
                      </th>
                      <th
                        class="scoreTableTodorhoilolt-hcell"
                        style="
                          border: 1px solid black;
                          text-align: left;
                          padding: 8px;
                          font-weight: bold !important;
                        "
                      >
                        Дүн
                      </th>
                      <th
                        class="scoreTableTodorhoilolt-hcell"
                        v-if="showDetails"
                        style="background-color: yellow"
                      >
                        Points
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(score, scoreIndex) in yearScore"
                      :key="'scoreRow' + scoreIndex + score.id"
                    >
                      <template v-if="sem == score.semester">
                        <td
                          class="scoreTableTodorhoilolt-cell"
                          style="
                            border: 1px solid black;
                            text-align: center;
                            border-spacing: 0px !important;
                            padding: 0px;
                            cursor: pointer;
                            width: 15%;
                          "
                        >
                          {{ _getScoreYear(score.year) }}
                        </td>
                        <td
                          class="scoreTableTodorhoilolt-cell"
                          style="
                            border: 1px solid black;
                            text-align: center;
                            border-spacing: 0px !important;
                            padding: 0px;
                            cursor: pointer;
                            width: 5%;
                          "
                        >
                          <span>{{ score.semester }} </span>
                        </td>
                        <td
                          class="scoreTableTodorhoilolt-cell text-uppercase px-1"
                          style="
                            border: 1px solid black;
                            text-align: center;
                            border-spacing: 0px !important;
                            padding: 0px;
                            cursor: pointer;
                            width: 5%;
                          "
                        >
                          {{ score.lessonCode }}
                        </td>
                        <td
                          class="scoreTableTodorhoilolt-cell px-2"
                          style="
                            text-align: start !important;
                            border: 1px solid black;
                            border-spacing: 0px !important;
                            padding: 0px;
                            cursor: pointer;
                            width: 45%;
                          "
                        >
                          <span v-if="score.lesson">{{
                            score.lesson.name
                          }}</span>
                          <span v-else class="red--text">АЛДААТАЙ </span>
                        </td>
                        <td
                          class="scoreTableTodorhoilolt-cell"
                          style="
                            border: 1px solid black;
                            text-align: center;
                            border-spacing: 0px !important;
                            padding: 0px;
                            cursor: pointer;
                          "
                        >
                          <span v-if="score.lesson">{{
                            score.lesson.credit
                          }}</span>
                          <span class="red--text" v-else>АЛДААТАЙ</span>
                        </td>
                        <td
                          class="scoreTableTodorhoilolt-cell"
                          style="
                            border: 1px solid black;
                            text-align: center;
                            border-spacing: 0px !important;
                            padding: 0px;
                            cursor: pointer;
                          "
                        >
                          {{ score.scoreTotal }}
                        </td>
                        <td
                          class="scoreTableTodorhoilolt-cell"
                          style="
                            border: 1px solid black;
                            text-align: center;
                            border-spacing: 0px !important;
                            padding: 0px;
                            cursor: pointer;
                          "
                        >
                          {{ _getGPAString(score.scoreTotal) }}
                        </td>
                        <td
                          v-if="showDetails"
                          class="scoreTableTodorhoilolt-cell"
                          style="background-color: yellow"
                        >
                          {{ score.gpaTotalPoint.toFixed(1) }}
                        </td>
                      </template>
                    </tr>

                    <tr style="border: 1px solid black; font-weight: bold">
                      <td></td>
                      <td class="font-weight-bold" style="min-width: 100px">
                        Кредит: {{ _getYearTotalCredit(yearScore, sem) }}
                      </td>
                      <td class="font-weight-bold">НИЙТ</td>

                      <td class="font-weight-bold text-end">
                        Үн.Голч:
                        {{ _getYearTotalScoreAverageGPA(yearScore, sem) }}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td
                        v-if="showDetails"
                        class="scoreTableTodorhoilolt-cell"
                        style="background-color: yellow"
                      >
                        {{ _getYearTotalGPAPoints(yearScore).toFixed(2) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </div>
          </div>
        </template>
        <p style="text-align: center; margin-top: 100px; margin-bottom: 20px">
          Зөвшөөрсөн оюутан ________________________
          {{
            student.lastName && student.lastName.length > 0
              ? student.lastName[0] + ". " + student.firstName
              : student.firstName
          }}
        </p>
        <p style="text-align: center; margin-top: 40px; margin-bottom: 20px">
          {{ signature }}
        </p>
      </v-container>
    </v-card>

    <v-card
      style="width: 1000px"
      class="mx-auto pt-5 pb-10"
      id="printMe"
      v-else
    >
      <div class="text-center" style="margin-top: 100px">
        <div style="font-size: 11pt; font-weight: bold" class="my-16">
          {{ name }}
        </div>
      </div>
      <div class="text-center" style="margin-top: 60px">
        <div style="font-size: 11pt">{{ description }}</div>
      </div>

      <div class="text-center" style="margin-top: 60px">
        <div class="my-10" style="font-size: 11pt; font-weight: bold">
          {{ signature }}
        </div>
      </div>
    </v-card>

    <v-container class="mt-2">
      <v-row justify="center">
        <v-btn class="secondary mx-auto" @click="_print">Xэвлэx</v-btn>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");
export default {
  name: "RegularTablesView",
  components: {},
  data: () => ({
    showDetails: false,
    allCreditPoints: null,
    allScore: 0,
    allCounter: 0,
    allCredit: 0,
    classInfo: null,
    loading: true,
    yearScores: {},
    years: null,
    studentScores: null,
    value: "",
    nochange: true,
    name: null,
    description: null,
    signature: null,
    item: null,
  }),
  watch: {},
  props: {
    itemRefPath: {
      required: true,
      type: String,
    },
    student: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    calculatedScoreTotal() {
      var xEnteredYear = 2019;
      var xCurrentYear = 2023;
      var sum = 0;
      if (this.yearScores) {
        for (var i = xEnteredYear; i <= xCurrentYear; i++) {
          var datas = this.yearScores[i + "-" + (i + 1 + "-1")];
          if (datas && datas.length > 0) {
            for (var k = 0; k < datas.length; k++) {
              if (datas[k].lesson && datas[k].lesson.credit) {
                sum = sum + parseFloat(datas[k].lesson.credit);
              }
            }
          }
        }
      }
      console.log(sum);
      return sum;
    },
  },
  created() {
    var xx =    "xClassGroupProgramRef-" +
          this.userProfile.school.currentSemesterYears +
          "-" +
          this.userProfile.school.currentSemester;
          var yy =    "xClassGroupProgram-" +
          this.userProfile.school.currentSemesterYears +
          "-" +
          this.userProfile.school.currentSemester;
    if (
      this.student &&
      this.student[xx] &&
      this.student[xx]
    ) {
      this.student[xx].get().then((doc) => {
        let classInfo = doc.data();
        classInfo.ref = doc.ref;
        classInfo.id = doc.id;
        classInfo.xProfession = null;
        classInfo.professionRef.get().then((doc) => {
          let xx = doc.data();
          xx.id = doc.id;
          xx.ref = doc.ref;
          classInfo.xProfession = xx;
        });
        this.classInfo = classInfo;
      });
    } else {
      if (
        this.student &&
        this.student[yy] &&
        this.student[yy].ref
      ) {
        this.student[yy].ref.get().then((doc) => {
          let classInfo = doc.data();
          classInfo.ref = doc.ref;
          classInfo.id = doc.id;
          classInfo.xProfession = null;
          classInfo.xprofessionRef.get().then((doc) => {
            let xx = doc.data();
            xx.id = doc.id;
            xx.ref = doc.ref;
            classInfo.xProfession = xx;
          });
          this.classInfo = classInfo;
        });
      }
    }

    var xEnteredYear = 2019;
    var xCurrentYear = 2023;
    for (var i = xEnteredYear; i <= xCurrentYear; i++) {
      this.yearScores[i + "-" + (i + 1) + "-" + 1] = [];
      this.yearScores[i + "-" + (i + 1) + "-" + 2] = [];
    }

    fb.db
      .doc(this.itemRefPath)
      .get()
      .then((doc) => {
        this.item = doc.data();
        this.item.ref = doc.ref;
        this.item.id = doc.id;
        this.name = this.item.name;

        var description = this.item.description;

        if (this.student.lastName && description)
          description = description.replaceAll(
            "$$LASTNAME",
            this.student.lastName
          );
        if (this.student.firstNamee && description)
          description = description.replaceAll(
            "$$FIRSTNAME",
            this.student.firstName
          );
        if (
          this.student.xprofession &&
          this.student.xprofession.namee &&
          description
        )
          description = description.replaceAll(
            "$$PROFESSION",
            this.student.xprofession.name
          );
        if (this.student.enteredYeare && description)
          description = description.replaceAll(
            "$$START_YEAR",
            this.student.enteredYear
          );
        if (this.student.finishedYeae && description)
          description = description.replaceAll(
            "$$END_YEAR",
            this.student.finishedYear
          );

        this.description = description;
        this.signature = this.item.signature;
      });
    // this.studentScores = [];

    // if (this.student.studentCode) this._searchStudentScore1("nee22d003");
    // this._searchStudentScore2("1Hm5oufwDvQpwJB4E3kZ");

    if (this.student.studentCode)
      this._searchStudentScore1(this.student.studentCode);
    // this._searchStudentScore2(this.student.id);
  },
  mounted() {
    this.nochange = true;
  },
  watch: {
    name: function () {
      this.nochange = false;
    },
    description: function () {
      this.nochange = false;
    },
    signature: function () {
      this.nochange = false;
    },
  },
  methods: {
    _confirmGPACalculation(allCreditPoints, allCredit) {
      console.log(this.student.ref.path, allCreditPoints, allCredit);

      var datas = {};

      if (allCredit > 0)
        datas._confirmed_calculated_GPA = parseFloat(
          (allCreditPoints / allCredit).toFixed(2)
        );

      datas["_confirmed_calculated_allCreditPoints"] = allCreditPoints;
      datas["_confirmed_calculated_allCredit"] = allCredit;
      datas["_confirmed_calculated_date"] = new Date();

      this.student.ref.update(datas).then(() => {
        console.log(this.student.ref.path, datas);
      });
    },
    _getYearTotalGPAPoints(yearScore) {
      var sum = 0;
      for (const xx of yearScore) {
        sum = sum + xx.gpaTotalPoint;
      }
      return parseFloat(sum);
    },
    _getYearTotalScoreAverageGPA(yearScore, sem) {
      var sum = 0;
      var zz = this._getYearTotalCredit(yearScore, sem);
      for (const xx of yearScore) {
        if (xx.semester == sem) {
          if (xx.lesson && xx.lesson.credit && xx.lesson.credit > 0) {
            sum =
              sum +
              parseFloat(this._getGPAPoint(xx.scoreTotal) * xx.lesson.credit);
          } else sum = sum + 0;
        }
      }
      if (zz > 0) return parseFloat(sum / zz).toFixed(1);
      else return 0;
    },
    _getYearTotalCredit(yearScore, sem) {
      var sum = 0;
      for (const xx of yearScore) {
        if (xx.semester == sem) {
          if (xx.lesson && xx.lesson.credit && xx.lesson.credit > 0) {
            sum = sum + parseFloat(xx.lesson.credit);
          } else sum = sum + 0;
        }
      }
      return sum;
    },

    calculatedScoreTotal2() {
      var xEnteredYear = 2019;
      var xCurrentYear = 2023;
      var sum = 0;
      if (this.yearScores) {
        for (var i = xEnteredYear; i <= xCurrentYear; i++) {
          var datas = this.yearScores[i + "-" + (i + 1 + "-1")];
          if (datas && datas.length > 0) {
            for (var k = 0; k < datas.length; k++) {
              if (datas[k].lesson && datas[k].lesson.credit) {
                sum = sum + parseFloat(datas[k].lesson.credit);
              }
            }
          }
        }
      }
      console.log(sum);
      return sum;
    },
    _getGPAString(score) {
      if (95 <= score && score <= 100) return "A+";
      else if (90 <= score && score <= 94) return "A";
      else if (87 <= score && score <= 89) return "B+";
      else if (80 <= score && score <= 86) return "B";
      else if (77 <= score && score <= 79) return "C+";
      else if (70 <= score && score <= 76) return "C";
      else if (60 <= score && score <= 69) return "D";
      else return "F,W,WF";
    },
    _getGPAPoint(score) {
      if (95 <= score && score <= 100) return 4;
      else if (90 <= score && score <= 94) return 3.7;
      else if (87 <= score && score <= 89) return 3.3;
      else if (83 <= score && score <= 86) return 3;
      else if (80 <= score && score <= 82) return 2.7;
      else if (77 <= score && score <= 79) return 2.3;
      else if (73 <= score && score <= 76) return 2;
      else if (70 <= score && score <= 72) return 1.7;
      else if (65 <= score && score <= 69) return 1.3;
      else if (60 <= score && score <= 64) return 1;
      else return 0;
    },
    _getScoreYear(str) {
      if (str) {
        var x = str.lastIndexOf("-");
        if (x > 0) return str.substring(0, x);
        else null;
      } else return str;
    },

    _getScoreSemester(str) {
      if (str) {
        var x = str.lastIndexOf("-");
        if (x > 0) return str.substring(x + 1);
        else null;
      } else return str;
    },
    _getScoreSemester2(score) {
      if (score.year) {
        var x = score.year.lastIndexOf("-");
        if (x > 0) return score.year.substring(x + 1);
        else null;
      } else return score.year;
    },
    _print() {
      this.$htmlToPaper("printMe");
    },
    _save() {
      this.item.ref
        .update({
          name: this.name ? this.name : null,
          description: this.description ? this.description : null,
          signature: this.signature ? this.signature : null,
        })
        .then(() => {
          this.nochange = true;
        });
    },

    _searchStudentScore1(studentCode) {
      fb.db
        .collectionGroup("yearScores")
        .where("studentCode", "==", studentCode)
        .onSnapshot((querySnapshot) => {
          var counter = 0;
          this.studentScores = [];
          this.allCreditPoints = 0;
          querySnapshot.forEach(async (doc) => {
            let score = doc.data();
            score.ref = doc.ref;
            score.id = doc.id;
            score.index = ++counter;
            score.lesson = null;

            if (score.lessonCode) {
              var datas = await fb.db
                .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
                .where("code", "==", score.lessonCode)
                .limit(1)
                .get();
              if (!datas.empty) {
                var doc = datas.docs[0];
                if (doc != null && doc.exists) {
                  score.lesson = doc.data();
                }
              } else {
                var datas = await fb.db
                  .collection(
                    "/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/"
                  )
                  .where("code", "==", score.lessonCode.toUpperCase())
                  .limit(1)
                  .get();
                if (!datas.empty) {
                  var doc = datas.docs[0];
                  if (doc != null && doc.exists) {
                    score.lesson = doc.data();
                  }
                }
              }
            }
            if (!score.lesson.isDiplomLesson) {
              score.year = score.ref.parent.parent.id;
              if (score.semester) {
                score.semester = score.semester;
              } else {
                if (score.lessonRef) {
                  var tt = await score.lessonRef.get();
                  if (tt.data().semesterRef) {
                    var sem = await tt.data().semesterRef.get();
                    score.semester = sem.data().shortName == "Намар" ? 1 : 2;
                  } else {
                    score.semester = "NOS";
                  }
                } else {
                  //xTODO NOWAY TODO DANGEROUS
                  var dd = score.createdAt.toDate();
                  if (dd.getFullYear() == "2023" && dd.getMonth() + 1 < 2) {
                    score.semester = 1;
                  } else {
                    score.semester = "ERROR - ERROR";
                  }
                  //no lessonRef

                  // if (score.lessonCode) {
                  //   var datas = await fb.db
                  //     .collection(
                  //       "/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/"
                  //     )
                  //     .where("code", "==", score.lessonCode)
                  //     .limit(1)
                  //     .get();
                  //   if (!datas.empty) {
                  //     var doc = datas.docs[0];
                  //     if (doc != null && doc.exists) {
                  //       var tt = await doc.ref.get();
                  //       if (tt.data().semesterRef) {
                  //         var sem = await tt.data().semesterRef.get();
                  //         score.semester =
                  //           sem.data().shortName == "Намар" ? 1 : 2;
                  //       } else {
                  //         score.semester = "NOS";
                  //       }
                  //     }
                  //   } else {
                  //     var datas = await fb.db
                  //       .collection(
                  //         "/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/"
                  //       )
                  //       .where("code", "==", score.lessonCode.toUpperCase())
                  //       .limit(1)
                  //       .get();
                  //     if (!datas.empty) {
                  //       var doc = datas.docs[0];
                  //       if (doc != null && doc.exists) {
                  //         score.lesson = doc.data();
                  //       }
                  //     }
                  //   }
                  // } else {
                  //   score.semester = "ERROR - ERROR";
                  // }
                }
              }
              this.yearScores[score.ref.parent.parent.id].push(score);
              if (score.lesson && score.lesson.credit) {
                this.allCredit =
                  this.allCredit + parseFloat(score.lesson.credit);
              }
              this.allCounter++;
              this.allScore = this.allScore + score.scoreTotal;

              if (score.lesson && score.lesson.credit > 0) {
                this.allCreditPoints =
                  this.allCreditPoints +
                  parseFloat(
                    this._getGPAPoint(score.scoreTotal) * score.lesson.credit
                  );

                score.gpaTotalPoint = parseFloat(
                  this._getGPAPoint(score.scoreTotal) * score.lesson.credit
                );
              } else {
                fb.db
                  .collection("_errored_scores")
                  .doc()
                  .set({ link: score.ref.path })
                  .then(() => {
                    console.log("fine.....", this.student.ref.path);
                    this.student.ref.update({ _errorScores: true });
                  });
              }
              this.studentScores.push(score);
            }
          });
          if (querySnapshot.empty) {
            this.errorMessage = "No Score!";
          }
          console.log(this.allCreditPoints);
        });
    },
    // _searchStudentScore2(studentCode) {
    //   fb.db
    //     .collectionGroup("yearScores")
    //     .where("id", "==", studentCode)
    //     .onSnapshot((querySnapshot) => {
    //       var counter = 0;
    //       var allCounter = 0;
    //       this.studentScores = [];
    //       querySnapshot.forEach(async (doc) => {
    //         let score = doc.data();
    //         score.ref = doc.ref;
    //         score.id = doc.id;
    //         score.index = ++counter;
    //         if (score.lessonCode) {
    //           var datas = await fb.db
    //             .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
    //             .where("code", "==", score.lessonCode)
    //             .limit(1)
    //             .get();
    //           if (!datas.empty) {
    //             var doc = datas.docs[0];
    //             if (doc != null && doc.exists) {
    //               score.lesson = doc.data();
    //             }
    //           } else {
    //             // this.accessOK = false
    //           }
    //         }
    //         score.year = score.ref.parent.parent.id;
    //         this.yearScores[score.ref.parent.parent.id].push(score);

    //         if (score.lesson && score.lesson.credit) {
    //           this.allCredit = this.allCredit + parseFloat(score.lesson.credit);
    //         }
    //         this.allCounter++;
    //         this.allScore = this.allScore + score.scoreTotal;

    //         console.log(score.scoreTotal)
    //         this.studentScores.push(score);
    //         console.log(
    //           score.schoolYear + "-" + score.semester,
    //           score.ref.parent.parent.id
    //         );
    //       });
    //       console.log(this.yearScores);
    //       this.loading = false;
    //       if (querySnapshot.empty) {
    //         this.errorMessage = "No Score!";
    //       }
    //     });
    // },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>
<style>
.scoreBorderedTable {
  border-collapse: collapse;
}
.scoreTableTodorhoilolt-hcell {
  border: 1px solid black;
  text-align: left;
  padding: 8px;
  font-weight: bold !important;
}
.scoreTableTodorhoilolt-cell {
  border: 1px solid black;
  text-align: center;
  border-spacing: 0px !important;
  padding: 0px;
  cursor: pointer;
}
</style>
